import {Button, Col, Row} from "reactstrap";
import $ from 'jquery';
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import _ from 'lodash';
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from "react";
import { CustomSubmitButton } from "../../Common/Components/Input/CustomSubmitButton";
import { StringToLowerCaseFirst } from "../../Common/Helpers/StringToLowerCaseFirst";
import RequestAdditionalInfo from "../Models/Request/RequestAdditionalInfo";
import RequestComment from "../Models/Request/RequestComment.js";
import RequestFile from "../Models/Request/RequestFile.js";
import { CustomButton } from "../../Common/Components/Button/CustomButton.js";
import { SlidePanel } from "../../Common/Components/Modal/SlidePanel";
import { GetDocumentGroupKey, UniqueByDocumentGroup } from "../Helpers/RequiredDocumentationGroup";

export function ReimbursementParticipants({setOtherFiles, otherFiles, setOtherComments, otherComments, data, onChange, onValidate, onCancel, editMode = false, accountingJson, extraField, setIsDeletedFile, setIsDeletedExtraFile, extraField2, setLocalDisplay, accordionStatus = false, setAccordionStatus = false, onChangeAditionalFields, requestFileList, requestCommentList, onDeleteOtherFile, onValidateFields}) {
    const { t } = useTranslation();
    const formDivRefParticipants = useRef(null);
    const [cancelModel, setCancelModel] = useState(data);
    const [wrongFileFormat, setWrongFileFormat] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState({});
    const [panelOpen, setPanelOpen] = useState(false);
    const hasInitialized = useRef(false);
    const prevDataSignature = useRef("");
    const initialDataRef = useRef(null);

    const captureSnapshot = () => {
        initialDataRef.current = _.cloneDeep(data);
    };
    // const handleAddFile = () => {
    //     const newFile = { id: Date.now() }; 
    //     setOtherFiles(prevFiles => [...prevFiles, newFile]);
    // };
    // const handleRemoveFile = (idToRemove) => {
    //     onDeleteOtherFile(idToRemove, "file");
    //     setOtherFiles(prevFiles => prevFiles.filter(file => file.id !== idToRemove));
    // };

    //  const handleOtherFileChange = (e, fileId) => {
    //     onChangeAditionalFields(e, "otherFile", "fileId", fileId);
    // }
    
    // const handleAddComment = () => {
    //     setOtherComments(prev => [...prev, { id: Date.now() }]);
    // };
    // const handleRemoveComment = (idToRemove) => {
    //     onDeleteOtherFile(idToRemove, "comment");
    //     setOtherComments(prev => prev.filter(comment => comment.id !== idToRemove));
    // };

    const handleNewFileUpload = (e) => {
        const newFileId = Date.now();
        onChangeAditionalFields(e, "otherFile", "fileId", newFileId);
    };

    const handleOtherCommentChange = (e, commentId) => {
        onChangeAditionalFields(e, "otherComment", "additionalInfo", commentId);
    };

    const codeExcluided = ["6611", "5990", "6590"];
    const gastosRelevantes = Array.isArray(data) ? data.filter(item => {
        return !codeExcluided.some(codigo => item.accountingName.includes(codigo));
    }) : [];    

    // One block per required documentation: expenses with the same required document share it,
    // even if their accountings are different
    const uniqueData = UniqueByDocumentGroup(gastosRelevantes);

    // Accounting names (codes) that share the block of the given item
    const GetGroupAccountingNames = (item) => {
        const key = GetDocumentGroupKey(item);
        const names = gastosRelevantes
            .filter(other => GetDocumentGroupKey(other) === key)
            .map(other => {
                const code = other?.accountingName ? [...other.accountingName.matchAll(/\(([^()]*)\)/g)].pop()?.[1] : null;
                return code || other?.accountingName || "";
            })
            .filter(name => name !== "");
        return [...new Set(names)];
    };

    const dataSignature = uniqueData
        .map(item => `${item.accountingId}:${item.selectedRadioOption ?? ""}`)
        .join("|");

    useEffect(() => {
        if (uniqueData.length === 0) return;
        const signatureChanged = prevDataSignature.current !== dataSignature;
        if (!hasInitialized.current || signatureChanged) {
            const initialOptions = {};
            uniqueData.forEach((item, index) => {
                if (item.selectedRadioOption) {
                    initialOptions[index] = item.selectedRadioOption;
                } else if (item.additionalInfo?.participantsFileId) {
                    initialOptions[index] = "option2";
                } else if (item.additionalInfo?.program || item.additionalInfo?.participantsNames) {
                    initialOptions[index] = "option1";
                } else if (hasInitialized.current && selectedOptions[index]) {
                    initialOptions[index] = selectedOptions[index];
                }
            });
            if (Object.keys(initialOptions).length > 0) setSelectedOptions(initialOptions);
            hasInitialized.current = true;
            prevDataSignature.current = dataSignature;
        }
    }, [dataSignature]);

    useEffect(() => {
        return () => {
            hasInitialized.current = false;
            prevDataSignature.current = "";
        };
    }, []);

    useEffect(() => {
        if (editMode) {
            setCancelModel(_.cloneDeep(data));
            captureSnapshot();
            if (setLocalDisplay) setLocalDisplay(true);
        }
    }, [editMode, data, setLocalDisplay]);

    // sync accordionStatus → open the panel
    useEffect(() => {
        if (accordionStatus) {
            captureSnapshot();
            setPanelOpen(true);
        }
    }, [accordionStatus]);

    const handleClose = () => {
        setPanelOpen(false);
        if (setAccordionStatus) setAccordionStatus(false);
    };

    const handleOptionChange = (index, event) => {
        const { value } = event.target;
        const item = uniqueData[index];
        $(`#errorRadio-${item.accountingId}`).addClass("d-none");
        setSelectedOptions(prev => ({
            ...prev,
            [index]: value,
        }));
        onChange(event, "radio", null, item.accountingId, index);
    };
    const hasUnsavedChanges = !_.isEqual(data, initialDataRef.current);

    return (
        <>
            {/* Trigger button */}
            <button
                type="button"
                onClick={() => {
                    captureSnapshot();
                    setPanelOpen(true);
                    if (setAccordionStatus) setAccordionStatus(true);
                }}
                className="rfc-trigger-btn-orange"
            >
                <div className="rfc-trigger-btn-left">
                    <i className="bx bx-file fs-5" />
                    {t('reimbursement.participantsAndPrograms')}
                    <span className="rfc-trigger-required">*</span>
                </div>
                <i className="bx bx-chevron-right fs-5" />
            </button>

            <SlidePanel
                isOpen={panelOpen}
                onClose={handleClose}
                title={t('reimbursement.participantsAndPrograms')}
                zIndexOffset={20}
                variant="center"
                closeOnOutsideClick={false}
            >
                <div ref={formDivRefParticipants} className="rfc-panel-body">

                    {/* OBLIGATORISK */}
                    <div>
                        <h6 className="rfc-obligatoriska-title">
                            Obligatorisk information <span className="rfc-participants-required">*</span>
                        </h6>

                        {uniqueData.length > 0 ? uniqueData.map((item, index) => {
                            const accountPosition = extraField?.length > 0
                                ? extraField.findIndex(d => d.accountingId === item.accountingId)
                                : -1;

                            const getFileProps = (field) => {
                                if (field.inputType === 'File' || field.requestName.includes('FileId')) {
                                    const fieldName = StringToLowerCaseFirst(field.requestName);
                                    const baseName = fieldName.replace(/Id$/, '');
                                    return {
                                        fileId: item?.additionalInfo?.[fieldName] || null,
                                        fileName: item?.additionalFileName || item?.additionalInfo?.[`${baseName}Extension`] || item?.additionalFileExtension || null,
                                        fileExtension: item?.additionalFileExtension || null,
                                        wrongFileFormat,
                                        setIsDeleted: setIsDeletedExtraFile
                                    };
                                }
                                return {};
                            };

                            if (item?.requiredDocumentation?.includes("Deltagarlista")) {
                                const allDynamicFields = accountPosition !== -1 ? extraField[accountPosition].extraFields : [];
                                const isOption1 = selectedOptions[index] === "option1";
                                const isOption2 = selectedOptions[index] === "option2";
                                
                                const fieldsToRender = isOption1
                                    ? allDynamicFields.filter(f => f.requestName !== 'ParticipantsFileId')
                                    : isOption2
                                        ? allDynamicFields.filter(f => f.requestName !== 'Program')
                                        : [];

                                return (
                                    <React.Fragment key={`item-${item.accountingId}`}>
                                        <div className="rfc-participants-section">

                                            {GetGroupAccountingNames(item).length > 1 && (
                                                <div className="text-green d-flex align-items-center mb-2">
                                                    <i className='bx bx-link fs-5 pe-2' />
                                                    Gäller för: {GetGroupAccountingNames(item).join(", ")}
                                                </div>
                                            )}

                                            {/* Toggle buttons visibles */}
                                            <div className="rfc-toggle-wrap">
                                                <button
                                                    type="button"
                                                    onClick={() => handleOptionChange(index, { target: { value: "option1" } })}
                                                    className={isOption1 ? "rfc-toggle-btn-active" : "rfc-toggle-btn-inactive"}
                                                >
                                                    Ange deltagare manuellt
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => handleOptionChange(index, { target: { value: "option2" } })}
                                                    className={isOption2 ? "rfc-toggle-btn-active-border" : "rfc-toggle-btn-inactive-border"}
                                                >
                                                    Bifoga deltagarlista som fil
                                                </button>
                                            </div>

                                            {/* Radio inputs ocultos */}
                                            <div id={`divRadioInputs-${item.accountingId}`} className="rfc-radio-hidden">
                                                <input
                                                    type="radio"
                                                    name={`options-${item.accountingId}`}
                                                    value="option1"
                                                    checked={selectedOptions[index] === "option1"}
                                                    onChange={(e) => handleOptionChange(index, e)}
                                                />
                                                <input
                                                    type="radio"
                                                    name={`options-${item.accountingId}`}
                                                    value="option2"
                                                    checked={selectedOptions[index] === "option2"}
                                                    onChange={(e) => handleOptionChange(index, e)}
                                                />
                                            </div>

                                            {fieldsToRender.map((field, idx) => (
                                                <div key={`field-${field.requestName}-${idx}`} className="position-relative">
                                                    <CustomInput
                                                        model={RequestAdditionalInfo}
                                                        attribute={StringToLowerCaseFirst(field.requestName)}
                                                        customField={field}
                                                        data={item?.additionalInfo[StringToLowerCaseFirst(field.requestName)]}
                                                        customChange={(e) => onChange(e, "dynamic", StringToLowerCaseFirst(field.requestName), item.accountingId, idx)}
                                                        {...getFileProps(field)}
                                                    />
                                                    {field.requestName === 'Program' && (
                                                        <div className="text-green d-flex align-items-center mb-3 mt-1">
                                                            <i className='bx bx-info-circle fs-5 pe-2' />
                                                            Skriv deltagarna i rutan eller kopiera in en deltagarlista från ett dokument <br />
                                                            (Använd "," eller en ny rad för att separera deltagare)
                                                        </div>
                                                    )}
                                                    <div id={`error${field.requestName}-${item.accountingId}`} className="error tooltip-custom-normal show-custom d-none rfc-error">
                                                        {t('validationMessage.fieldRequired')}
                                                    </div>
                                                </div>
                                            ))}

                                            <div id={`errorRadio-${item.accountingId}`} className="error tooltip-custom show-custom d-none rfc-error">
                                                {t('formPlaceholder.selectOption')}
                                            </div>
                                        </div>

                                        {index < uniqueData.length - 1 && <hr className="my-2" />}
                                    </React.Fragment>
                                );
                            } else {
                                if (accountPosition === -1) return null;
                                return (
                                    <div key={`item-${item.accountingId}`} className="rfc-participants-section">
                                        {GetGroupAccountingNames(item).length > 1 && (
                                            <div className="text-green d-flex align-items-center mb-2">
                                                <i className='bx bx-link fs-5 pe-2' />
                                                Gäller för: {GetGroupAccountingNames(item).join(", ")}
                                            </div>
                                        )}
                                        {extraField[accountPosition].extraFields.map((field, idx) => (
                                            <div key={`field-${field.requestName}-${idx}`} className="position-relative">
                                                <CustomInput
                                                    model={RequestAdditionalInfo}
                                                    attribute={StringToLowerCaseFirst(field.requestName)}
                                                    customField={field}
                                                    data={item?.additionalInfo[StringToLowerCaseFirst(field.requestName)]}
                                                    customChange={(e) => onChange(e, "dynamic", StringToLowerCaseFirst(field.requestName), item.accountingId, index)}
                                                    {...getFileProps(field)}
                                                />
                                                <div id={`error${field.requestName}-${item.accountingId}`} className="error tooltip-custom-normal show-custom d-none rfc-error">
                                                    {t('validationMessage.fieldRequired')}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                );
                            }
                        }) : (
                            <p>Inga ytterligare bilagor krävs</p>
                        )}

                        {uniqueData.length > 0 && (
                            <div style={{ marginBottom: 8 }}>
                                <CustomSubmitButton
                                    text={editMode ? t('button.save') : t('reimbursement.addParticipants')}
                                    customClick={async () => {
                                        const hasErrors = await onValidate();
                                        if (!hasErrors) {
                                            setPanelOpen(false);
                                            if (setAccordionStatus) setAccordionStatus(false);
                                        }
                                    }}
                                    typeFile={true}
                                    formDivRef={formDivRefParticipants}
                                    customClass="w-100 py-3"
                                />
                            </div>
                        )}
                    </div>

                    {/* ÖVRIGA KOMMENTARER */}
                    <div className="rfc-comments-section">
                        <h6 className="rfc-comments-title">Övriga kommentarer</h6>
                        <div className="rfc-comments-subtitle">Detta fält är frivilligt</div>

                        {/* Uploaded files list */}
                        {requestFileList.map((uploadedFile) => (
                            <div key={uploadedFile.id} className="rfc-file-row">
                                <i className="bx bxs-file fs-4 text-green" />
                                <span className="text-green rfc-file-name">{uploadedFile.fileName}</span>
                                <CustomButton
                                    text=""
                                    icon='bx bx-trash-alt py-1'
                                    iconColor='#EB5757'
                                    iconSize={5}
                                    buttonColor='#e9cbcd'
                                    buttonRadius={3}
                                    hoverButtonRadius={3}
                                    hoverIconColor='white'
                                    hoverButtonColor='#EB5757'
                                    customClasses="border-0"
                                    tooltipText={t('button.delete')}
                                    onClick={() => onDeleteOtherFile(uploadedFile.id, "file")}
                                />
                            </div>
                        ))}

                        {/* Comments */}
                        {otherComments.map((comment) => {
                            const commentData = requestCommentList.find(item => item.id === comment.id);
                            return (
                                <div key={comment.id} className="rfc-comment-wrap">
                                    <CustomInput
                                        model={RequestComment}
                                        attribute="comment"
                                        customChange={(e) => handleOtherCommentChange(e, comment.id)}
                                        data={commentData?.comment || ""}
                                    />
                                </div>
                            );
                        })}

                        {/* New file upload */}
                        <div className="rfc-new-file-wrap">
                            <CustomInput
                                model={RequestFile}
                                attribute="fileId"
                                customChange={handleNewFileUpload}
                                fileId={null}
                                fileName={null}
                                fileExtension={null}
                                validateAttribute={true}
                            />
                        </div>
                    </div>

                    {/* Lägg till alla */}
                    <button
                        type="button"
                        onClick={async () => {
                            const hasErrors = await onValidate();
                            if (!hasErrors) {
                                onValidateFields();
                                setPanelOpen(false);
                                if (setAccordionStatus) setAccordionStatus(false);
                            }
                        }}
                        className="rfc-footer-btn"
                    >
                        Lägg till Utlägg
                    </button>

                </div>
            </SlidePanel>
        </>
    );
}